export class ImageService {
  static imageMaxWidth = 800;
  static imageQuality = 0.8;

  static getImageDataFromFileAndResizeIfNeeded(file: any): Promise<string> {
    return new Promise<string>((resolve) => {
      ImageService.getImageFromFile(file).then((image: HTMLImageElement) => {
        const imageData = ImageService.getImageDataAndResizeIfNeeded(image);
        resolve(imageData);
      });
    });
  }

  static getImageFromFile(file: any): Promise<HTMLImageElement> {
    return new Promise<HTMLImageElement>((resolve) => {
      const image = new Image();
      image.src = URL.createObjectURL(file);
      image.onload = () => {
        resolve(image);
      };
    });
  }

  static getImageDataAndResizeIfNeeded(image: HTMLImageElement): string {
    // Inspired by a couple of topics
    // https://stackoverflow.com/questions/27122713/resize-image-using-javascript
    // https://stackoverflow.com/questions/19262141/resize-image-with-javascript-canvas-smoothly

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');

    if (image.width > ImageService.imageMaxWidth) {
      canvas.width = ImageService.imageMaxWidth;
      canvas.height = canvas.width * (image.height / image.width);
    } else {
      canvas.width = image.width;
      canvas.height = image.height;
    }

    ctx?.drawImage(image, 0, 0, canvas.width, canvas.height);

    return canvas.toDataURL('image/jpeg', ImageService.imageQuality);
  }
}
